import React from 'react';
import { Link } from 'react-router-dom';
import { Compass, Phone } from 'lucide-react';
export function DoSomeMartialArtsHeroInfo() {
  return <div className="flex flex-col items-start" data-id="element-955">
      <div className="inline-flex items-center gap-2 bg-storm-red text-white px-4 py-1.5 rounded-full text-sm font-bold uppercase tracking-wide mb-6" data-id="element-956">
        <Compass className="w-4 h-4" data-id="element-957" />
        Beginner-Friendly · No Experience Needed
      </div>

      <div className="mb-8 inline-flex flex-nowrap items-center gap-3 text-sm md:text-base font-bold text-ink bg-white/90 backdrop-blur-sm py-2 px-4 rounded-full shadow-sm border border-subtle-gray w-fit max-w-full whitespace-nowrap" data-id="element-958">
        <span className="text-gold tracking-wider shrink-0" data-id="element-959">★★★★★</span>
        <span className="text-subtle-gray shrink-0" data-id="element-960">|</span>
        <span className="shrink-0" data-id="element-961">5.0 Rating From 201 Reviews</span>
      </div>

      <h1 className="text-4xl md:text-5xl lg:text-6xl text-white mb-6 leading-[1.1]" data-id="element-962">
        Thinking About Trying Martial Arts?
      </h1>

      <p className="text-xl text-off-white mb-8 max-w-xl leading-relaxed" data-id="element-963">
        Storm Taekwondo helps beginners of all ages start with confidence
        through structured classes and programs for kids, adults, and families
        in Farmington Hills.
      </p>

      <div className="flex flex-col sm:flex-row gap-4 w-full sm:w-auto mb-10" data-id="element-964">
        <Link to="/SignMeUp" className="btn-primary" data-id="element-965">
          Start With a Trial Class
        </Link>
        <Link to="/Programs.html" className="btn-secondary" data-id="element-966">
          View Classes & Programs
        </Link>
      </div>

      <div className="flex items-start gap-3 text-off-white/80 text-sm" data-id="element-967">
        <Phone className="w-5 h-5 text-storm-red shrink-0 mt-0.5" data-id="element-968" />
        <p data-id="element-969">
          Have a question first?{' '}
          <a href="tel:517-220-0621" className="text-white font-bold hover:underline" data-id="element-970">
            Call 517-220-0621
          </a>{' '}
          — a Storm coach will help you pick the right starting class.
        </p>
      </div>
    </div>;
}